import React from "react";

const Text13 = () => {

  React.useEffect(() => {
    // 👇️ scroll to top on page load, behavior can be snappy with 'auto'
    document.getElementById('top')?.scrollIntoView({ behavior: 'smooth' });}
    , []);

    return(
      <>
        <p className="content-heading" id="top">
          Kontakt
        </p>

      <div className="content-text mt-4">
        
        <p>
          Maila oss på <span className="textdark fw-bold"><i>info@byggbusiness.com</i></span> så vill vi seriöst begrunda och 
          – såvitt tillämpligt – åtgärda bugs och införa nya förslag.       
        </p>    
        <p>
          För snabbare respons är du också välkommen att kontakta 
          Kundtjänst hos Småföretagarnas Riksförbund på <span className="textdark fw-bold"><i>tfn: 042-34 28 50</i></span>. 
          Du kan även maila på <span className="textdark fw-bold"><i>småföretagarna.123@gmail.com</i></span>
        </p>
       
      </div>
    </>
  );
}
export default Text13;